function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 16C5 12.6863 7.68629 10 11 10C12.9618 10 14.7035 10.9399 15.8008 12.4003L18.1992 10.5983C16.5598 8.41613 13.945 7 11 7C6.02944 7 2 11.0294 2 16C2 20.9706 6.02944 25 11 25C13.945 25 16.5598 23.5839 18.1992 21.4017L15.8008 19.5997C14.7035 21.0601 12.9618 22 11 22C7.68629 22 5 19.3137 5 16ZM24.4998 14.4333V12.0008C24.4998 11.5769 24.9942 11.3453 25.3199 11.6167L30.0389 15.5491C30.2787 15.749 30.2787 16.1174 30.0389 16.3173L25.3199 20.2498C24.9942 20.5212 24.4998 20.2897 24.4998 19.8657V17.4333H18.9998C18.1714 17.4333 17.4998 16.7617 17.4998 15.9333C17.4998 15.1048 18.1714 14.4333 18.9998 14.4333H24.4998ZM13.0667 16C13.0667 17.1046 12.1712 18 11.0667 18C9.96209 18 9.06666 17.1046 9.06666 16C9.06666 14.8954 9.96209 14 11.0667 14C12.1712 14 13.0667 14.8954 13.0667 16Z",
  fill: "white"
});

var SvgIcMenuSources = function SvgIcMenuSources(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMenuSources, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-menu-sources.17551c2a.svg";
export { ForwardRef as ReactComponent };